import { Component, h, Host, Element, Listen, Prop, Watch } from '@stencil/core';
import { addClass, inheritAttributes } from '../../utils/helpers/helpers';

@Component({
  tag: 'lgr-tab',
  styleUrl: 'tab.scss',
  shadow: true,
})
export class Tab {
  @Element() el!: HTMLLgrTabElement;
  /**
   * Inverse or not. This value will be aplied globally to all tab items.
   */
  @Prop({ reflect: true }) inverse: boolean = false;
  /**
   * Disabled or not. This value will be aplied globally to all tab items.
   */
  @Prop({ reflect: true }) disabled: boolean = false;
  /**
   * Indicates whether the border should be placed under the entire width or
   * only below the tag names.
   */
  @Prop({ reflect: true }) fullWidth: boolean = false;

  private slot!: HTMLSlotElement;
  private itemsSlot!: HTMLLgrTabItemElement[];
  private inheritedAttributes: { [key: string]: string } = {};

  @Listen('lgrTabItemSelected', { target: 'body' })
  handleTabItemSelection(e: CustomEvent) {
    if (!this.itemsSlot.includes(e.target as HTMLLgrTabItemElement)) return;

    this.itemsSlot.forEach(element => {
      if (element !== e.target) {
        (element as HTMLLgrTabItemElement).selected = false;
      }
    });
  }

  @Watch('inverse')
  handleInverseChange() {
    this.itemsSlot.map(el => (el.inverse = this.inverse));
  }

  @Watch('disabled')
  handleDisabledChange() {
    this.itemsSlot.map(el => (el.disabled = this.disabled));
  }

  componentDidLoad() {
    try {
      this.itemsSlot = this.slot
        .assignedElements()
        .filter(el => el.tagName.toLowerCase() === 'lgr-tab-item')
        .map(el => el as HTMLLgrTabItemElement);
    } catch {
      return;
    }

    const selected = this.itemsSlot.filter(el => el.selected);

    if (selected.length === 0) {
      this.itemsSlot[0].selected = true;
    } else {
      selected.shift();
      selected.forEach(el => (el.selected = false));
    }

    if (this.inverse) {
      this.itemsSlot.map(el => (el.inverse = this.inverse));
    }
    if (this.disabled) {
      this.itemsSlot.map(el => (el.disabled = true));
    }
  }

  async componentWillLoad(): Promise<void> {
    this.inheritedAttributes = inheritAttributes(this.el, ['aria-labelledby']);
  }

  render() {
    return (
      <Host>
        <ul
          role="tablist"
          aria-role="tablist"
          aria-labelledby={this.inheritedAttributes['aria-labelledby']}
          class={addClass(['lgr-tab-items-container', this.inverse ? 'inverse' : null, this.fullWidth ? 'full-width' : null])}
        >
          <slot
            name="items"
            ref={el => {
              this.slot = el as HTMLSlotElement;
            }}
          ></slot>
        </ul>

        <div class="lgr-tab-content-container">
          <slot name="content"></slot>
        </div>
      </Host>
    );
  }
}
